// extracted by mini-css-extract-plugin
export var button = "DatasetPreview-module--button--b0d73";
export var buttonsContainer = "DatasetPreview-module--buttonsContainer--a6199";
export var container = "DatasetPreview-module--container--c9ff8";
export var previewContainer = "DatasetPreview-module--previewContainer--1a058";
export var resultsTable = "DatasetPreview-module--resultsTable--cd4c5";
export var tableNameLabel = "DatasetPreview-module--tableNameLabel--2b073";
export var typesTable = "DatasetPreview-module--typesTable--0630a";